module.exports = __webpack_public_path__ + "img/solution-bg-1.1ba6cbe4.png";